import http from '@/services/http.js';

const MATERIAL_API = '/videoapi/material';
const MATERIAL_LIST_API = '/videoapi/material/list';
const MATERIAL_UPLOAD_API = '/videoapi/material/upload';
const CATEGORY_API = '/videoapi/category';
const CATEGORY_LIST_API = '/videoapi/category/list';

export const fetchMaterialCategories = async (params = {}) => {
  const response = await http.get(CATEGORY_LIST_API, {
    params,
  });
  return response.data.data || [];
};

export const createMaterialCategory = async (payload) => {
  const response = await http.post(CATEGORY_API, payload);
  return response.data.data;
};

export const updateMaterialCategory = async (categoryId, payload) => {
  const response = await http.put(`${CATEGORY_API}/${categoryId}`, payload);
  return response.data.data;
};

export const deleteMaterialCategory = async (categoryId) => {
  const response = await http.delete(`${CATEGORY_API}/${categoryId}`);
  return response.data.data;
};

export const fetchVideoMaterials = async (params = {}) => {
  const response = await http.get(MATERIAL_LIST_API, {
    params,
  });
  return response.data.data || [];
};

export const uploadVideoMaterial = async (payload) => {
  const response = await http.post(MATERIAL_UPLOAD_API, payload);
  return response.data.data;
};

export const updateVideoMaterial = async (materialId, payload) => {
  const response = await http.put(`${MATERIAL_API}/${materialId}`, payload);
  return response.data.data;
};

export const deleteVideoMaterial = async (materialId) => {
  const response = await http.delete(`${MATERIAL_API}/${materialId}`);
  return response.data.data;
};
